module.exports = __webpack_public_path__ + "static/media/shared_data_icon.f762f113.svg";